export default __webpack_public_path__ + "static/media/irbis_white_s.d75ba579.png";